import baseAxios from "axios";

export const BASE_URL = process.env.REACT_APP_API_URL;

export const axios = baseAxios.create({
    baseURL: BASE_URL,
    headers: { "Content-Type": "application/json" },
})